// Validates URL format and protocol (works in both Node.js and browser)
export const isValidUrl = (url: string): boolean => {
  if (url.startsWith("/")) return true;

  try {
    const urlObj = new globalThis.URL(url);
    const validProtocols = ["http:", "https:", "mailto:"];
    return validProtocols.includes(urlObj.protocol);
  } catch {
    return false;
  }
};

// Validates URL and returns error message
export const validateUrlWithMessage = (
  url: string,
  errorMessages?: {
    errorUrlEmpty?: string;
    errorUrlProtocol?: string;
    errorUrlInvalid?: string;
  }
): string => {
  if (!url.trim()) return errorMessages?.errorUrlEmpty || "";

  if (url.startsWith("/")) return "";

  if (!isValidUrl(url)) {
    try {
      new globalThis.URL(url);
      return errorMessages?.errorUrlProtocol || "";
    } catch {
      return errorMessages?.errorUrlInvalid || "";
    }
  }

  return "";
};
